<template>
  <div class="flex flex-col justify-center items-center ">
    <div class="mb-3 font-bold">{{ data.title }}</div>
    <a :href="`mailto:${data.email}`" class="flex flex-col min-w-[170px] justify-center items-center text-center p-6 rounded-xl bg-blue-450/10 [&>*]:my-1 text-sm font-bold">
      <div class="w-16 mb-4">
        <BaseIcon :name="data.icon" />
      </div>
      {{ data.email }}
    </a>
  </div>
</template>

<script setup>
defineProps({
  data: Object,
})
</script>